import { useCallback, useEffect } from 'react';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';

/**
 * Event fires when request with PAS was rejected with error.
 * @memberOf Playtech.API.events
 * @event pas-error
 * @type {callback}
 * @param {object} detials
 * @param {number} details.actionName - name of the action that was requested.
 * @param {number} details.error - error object received from PAS (or fake one in case of timeout).
 * @param {number} details.time - Time it took to make the request is ms.
 * @example Playtech.on('pas-error', ({ actionName, error, time }) => { ... });
 */
export const PAS_ERROR = 'pas-error';

export const useOnPASError = (eventTarget: EventTarget): void => {
    const triggerPASErrorEvent = useCallback((detail: {
        actionName: string;
        error: object;
        time: number;
    }) => {
        const event = new CustomEvent(PAS_ERROR, { detail });

        eventTarget.dispatchEvent(event);
    }, [eventTarget]);

    useEffect(() => {
        publicEventsAPIService.on('pas-error', triggerPASErrorEvent);

        return () => {
            publicEventsAPIService.off('pas-error', triggerPASErrorEvent);
        };
    }, [triggerPASErrorEvent]);
};
